import { ChartTypes } from '@/utils/enum'

export const PropChartType = {
  props: {
    chartType: {
      required: false,
      default: ChartTypes.Line,
      validator(type) {
        return Object.values(ChartTypes).includes(type)
      },
    },
  },
}
